import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';
import { Claim } from '@wsphere/warranties/domain';

@Injectable()
export class ClaimResolver implements Resolve<Claim.Model | null | RedirectCommand> {
  claim!: Claim.Model | null;

  async resolve(): Promise<Claim.Model | null> {
    return this.claim ?? null;
  }
}
